const news = state => state.news;

const newsLoading = state => state.newsLoading;

const singleNews = state => state.singleNews;

const singleNewsLoading = state => state.singleNewsLoading;

const categories = state => state.categories;

const categoriesLoading = state => state.categoriesLoading;

const tags = state => state.tags;

const tagsLoading = state => state.tagsLoading;

const newsMeta = state => state.meta;

const latestNews = state => state.latestNews;

const latestNewsLoading = state => state.latestNewsLoading;

export default {
  news,
  newsLoading,
  singleNews,
  singleNewsLoading,
  categories,
  categoriesLoading,
  tags,
  tagsLoading,
  newsMeta,
  latestNews,
  latestNewsLoading
};
